/* assets/tooltip.js  – new, delegation-based version */
(function () {
  /* toggle */
  document.addEventListener("click", (e) => {
    const trigger = e.target.closest(".tooltip-trigger");
    if (trigger) {
      e.stopPropagation();
      const popup = trigger.nextElementSibling;
      if (popup) popup.classList.toggle("hidden");
      return;
    }

    const closeBtn = e.target.closest(".tooltip-close");
    if (closeBtn) {
      e.stopPropagation();
      closeBtn.parentElement.classList.add("hidden");
      return;
    }

    /* click anywhere else → close every open tooltip */
    if (!e.target.closest(".tooltip-popup")) {
      document
        .querySelectorAll(".tooltip-popup:not(.hidden)")
        .forEach((p) => p.classList.add("hidden"));
    }
  });

  /* Esc key closes any open tooltip */
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape")
      document
        .querySelectorAll(".tooltip-popup:not(.hidden)")
        .forEach((p) => p.classList.add("hidden"));
  });
})();
